/**
 * Build PostgREST .or() filters for multi-word search.
 * Returns one filter string per word. Chain them with .or() calls
 * to get AND-across-words, OR-across-fields semantics server-side.
 */
export function buildMultiWordFilter(
  searchTerm: string,
  fields: string[]
): { filterStrings: string[]; clientFilter: null } {
  const words = searchTerm.toLowerCase().trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return { filterStrings: [], clientFilter: null };

  const filterStrings = words.map(word =>
    fields.map(f => `${f}.ilike.%${word}%`).join(',')
  );

  return { filterStrings, clientFilter: null };
}
